// extracted by mini-css-extract-plugin
module.exports = {"ai_taste":"ai_taste___3ZnbV","ai_title":"ai_title___D8jFS","ai_smalltitle":"ai_smalltitle___3MGRs","button":"button___2v0uo","button1":"button1___sJXiB"};